import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    
    /** 获取推广渠道信息列表 **/
    GET_PROMOTION_TYPE_LIST(data) {
        controller='EsPromotion';
        action='GetPromotionTypes';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 查看推广信息列表 **/
    GET_PROMOTION_LIST(data) {
        controller='EsPromotion';
        action='GetPromotionList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 查看推广信息详情 **/
    GET_PROMOTION_INFO(data) {
        controller='EsPromotion';
        action='GetPromotionInfo';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 删除推广信息 **/
    DEL_PROMOTION(data) {
        controller='EsPromotion';
        action='DelPromotion';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 新增推广信息 **/
    ADD_PROMOTION(data) {
        controller='EsPromotion';
        action='AddPromotion';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 更新推广信息 **/
    UPDATE_PROMOTION(data) {
        controller='EsPromotion';
        action='EditPromotion';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

}